<template>
  <!--  -->
  <div class="side-panel left com-left hf osy ml-30">
    <div class="side-panel-bg">
      <div class="pb-5 pr-20 ml-20 thisMonthData">
        <h1 class="f-20 c-satwo">
          <span>算力设备监控 <img src="/imgs/complianceTitleIcon.png" class="ml-10"></span>
        </h1>
        <div class="fr ov mt-10">
          <div class="dev-count-pane fr ac jc ov" style="margin-right: 8px;">
            <div class="dev-logo"></div>
            <div class="dev-data fc ov">
              <div class="dev-data-count fr ac jc ov">
                <div class="dev-decorate"/>
                <div class="dev-data-bar fc jc ov">
                  <div>监测设备</div>
                  <div class="mt-10" style="font-size: 22px; font-family: aldrich, serif; ">
                    {{ devCount.equipment_num }}
                  </div>
                </div>
              </div>
              <div class="dev-data-count fr ac jc ov">
                <div class="dev-decorate"/>
                <div class="dev-data-bar fc jc ov">
                  <div style="font-size: 18px; font-family: aldrich, serif; color: #F0D544;">
                    <span>{{ devCount.online }}</span><span style="margin-left: 26px;">{{ devCount.offline }}</span>
                  </div>
                  <div class="mt-5" style="font-size: 10px;">
                    <span style="margin-left: 8px;">在线</span><span style="margin-left: 28px;">离线</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="dev-warning-pane" style="margin-bottom: 8px;">
              <div class="dev-data-bar fc jc ov">
                <div>告警设备数</div>
                <div class="mt-10" style="font-size: 22px; font-family: aldrich, serif; color: #50D1FF;">
                  {{ devCount.alarm_device }}
                </div>
              </div>
            </div>
            <div class="dev-warning-pane">
              <div class="dev-data-bar fc jc ov">
                <div>告警信息数</div>
                <div class="mt-10" style="font-size: 22px; font-family: aldrich, serif; color: #50D1FF;">
                  {{ devCount.alarm_num }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- -------------------------------------------------------------------------------------- -->
      <div class="pt-10 pl-20 pb-5 pr-20  thisMonthData">
        <h1 class="f-20 c-satwo">
          <span>视频监控 <img src="/imgs/complianceTitleIcon.png" class="ml-10"></span>
        </h1>
        <div class="">
          <div class="dcvideoAlarm">
            <div class="videoLft">视频监控告警：<span>119</span></div>
            <div class="videoRt"><a href="#">视频监控 <img src="/imgs/blikunnewsicon.png"></a></div>
          </div>
          <div class="dcvideoVideo">
            <div class="videoVideoLft"><img src="/imgs/videoImgs/video03.png" class="video-img" /></div>
            <div class="videoVideoRt"><img src="/imgs/videoImgs/video02.png" class="video-img" /></div>
          </div>
          <div class="dcvideoVideo">
            <div class="videoVideoLft"><img src="/imgs/videoImgs/video01.png" class="video-img" /></div>
            <div class="videoVideoRt"><img src="/imgs/videoImgs/video05.png" class="video-img" /></div>
          </div>
        </div>
        
      </div>

      <!-- -------------------------------------------------------------------------------------- -->
      <div class="pt-20 pl-20 pb-5 pr-20  thisMonthData">
        <h1 class="f-20 c-satwo">
          <span>安防监控 <img src="/imgs/complianceTitleIcon.png" class="ml-10"></span>
        </h1>
        <div class="doorModle">
          <h4>门禁状态</h4>
          <div class="fr jc ac ov mb-10">
            <div v-for="item in doorStatus" :key="item.name" class="fc">
              <div class="monitorDoorTxt">
                {{ item.current_state }}
              </div>
              <div class="pane-data-value"><img :src="getImageSrc(item.current_state)"></div>
              <div class="pane-data-label">{{ item.name }}</div>
            </div>
          </div>
          <div class="pane-overall">
            <div class="monitorDoor2Cont">
              <h4 class="monitorDoortitle"><img src="/imgs/monitorDoor2.png"> 烟雾告警</h4>
              <div class="fr jc ac ov mb-10">
                <div v-for="item in smokeAlarm" :key="item.name" class="fr jc ac">
                  <div class="pane-data-value2"><img src="/imgs/monitorDoor2cont.png"></div>
                  <div class="monitorDoorTxt2">{{ item.name }}：</div>
                  <div class="pane-data-label2">{{ item.alarm_total }}</div>
                </div>
              </div>
            </div>
            <div class="monitorDoor2Cont">
              <h4 class="monitorDoortitle"><img src="/imgs/monitorDoor3.png"> 水浸告警：</h4>
              <div class="fr jc ac ov mb-10">
                <div v-for="item in waterAlarm" :key="item.name"  class="fr jc ac monitorDoor3">
                  <div class="monitorDoorTxt2">{{ item.name }}：</div>
                  <div class="pane-data-label2">{{ item.alarm_total }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- -------------------------------------------------------------------------------------- -->

    </div>
  </div>
</template>

<script>

export default {
  name: 'com-left',
  components: {},
  props: {
    resData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      devCount: {},
      doorStatus: [],
      smokeAlarm: {},
      waterAlarm: [],
    }
  },
  mounted() {
    this.$nextTick(function () {
      // 初始化dom相关数据
      setTimeout(() => {
        this.devCount = this.resData.devCount
        this.doorStatus = this.resData.doorStatus
        this.smokeAlarm = this.resData.smokeAlarm
        this.waterAlarm = this.resData.waterAlarm
      }, 300)
    })
  },
  methods: {
    getImageSrc(state) {
      return state === '开' ? '/imgs/monitorDooropen.png' : '/imgs/monitorDoorclose.png';
    }
  }
}
</script>

<style lang="scss" scoped>
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/

.dev-count-pane {
  width: 292px;
  height: 204px;
  background: url(/imgs/monitor-frameBgBorder.png) no-repeat;
  background-size: 100% 100%;
}

.dev-warning-pane {
  width: 129px;
  /*height: 74px;*/
  height: 98px;
  background: url(/imgs/monitor-frame.png) no-repeat;
  background-size: 100% 100%;
}

.dev-logo {
  width: 100px;
  height: 100%;
  background: url(/imgs/monitor-device-logo.png) no-repeat center;
  background-size: contain;
}

.dev-data {
  width: 130px;
  height: 100%;
}

.dev-data-count {
  width: 100%;
  height: 50%;
}

.dev-decorate {
  width: 40px;
  height: 100%;
  background: url(/imgs/monitor-dev-decorate.png) no-repeat center;
  background-size: contain;
}

.dev-data-bar {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  align-items: center;
}

/**********************************************************************************************************/

.dcvideoAlarm {
  width: 100%;
  overflow: hidden;
  padding-top:15px;
}

.videoLft {
  float: left;
}

.videoLft span {
  color: #FF9494;
  font-size: 18px;
  font-family: aldrich, serif;
}

.videoRt {
  float: right;
  color: #00FDFD;
}

.dcvideoVideo {
  margin-top: 10px;
  width: 100%;
  overflow: hidden;
}

.videoVideoLft {
  float: left;
  width: 49%;
  height: 100px;
  background: #123f46;
}

.videoVideoRt {
  float: right;
  width: 49%;
  height: 100px;
  background: #123f46;
}

.video-img {
  width: 100%;
  height: 100px;
}

/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/


.side-panel-bg {
  background: rgba(0, 0, 0, 0) !important;
}

.thisMonthData {
  .bleftOne > div {
    background: url(/imgs/border-leftOne.png) no-repeat;
    width: 120px;
    height: 69px;
    background-size: 100% 69px;
  }

  .bleftTwo > div {
    background: url(/imgs/border-leftTwo.png) no-repeat;
    height: 68px;
    background-size: 100%;
  }
}

.bleftThree {
  background: url(/imgs/border-leftThree.png) no-repeat;
  height: 225px;
  background-size: 100%;
  padding: 5px 0;
}


.c-satwo {
  background: url(/imgs/complianceTitle.png) no-repeat;
  height: 40px;

}

.c-satwo span {
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 0;
  font-weight: 400;
  padding-left: 37px;
  line-height: 40px;
}
.doorModle{
  padding-top: 10px;
}
.doorModle h4{
  font-size: 12px;
  color: #FFF1D9;
  letter-spacing: 0;
  font-weight: 400;
  padding-bottom: 5px;
}
.monitorDoorTxt{
    /* font-size: -webkit-xxx-large; */
    /* width: 8px; */
    font-size: 10px;
    width: 66px;
    text-align: center;
}
.pane-data-value{
  position: relative;
  top: -43px;
}
.pane-data-label{
  position: relative;
  top: -71px;
  left: 20px;
}
.pane-overall{
  background: rgba(0, 145, 133, 0.12);
  height: 166px;
  margin-top: -70px;
}

.monitorDoortitle{
  padding: 10px 12px 0;

}
.monitorDoorTxt2{
  font-size: 10px;
  width: 37px;
  color: #f5f5f5;
}
.pane-data-label2{
  font-size: 14px;
  color: #66FFFF;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 400;
  padding-right: 10px;
  font-family: aldrich, serif;
}
.monitorDoor3{
  width: 89px;
  height: 37px;
  background: rgba(0, 145, 133, 0.12);
  margin-right: 10px;

}
</style>
